const IntegrationRedirectApiUrls = {
  TOKEN_EXCHANGE: ` ${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/integration/token-exchange`
};
  
  export default IntegrationRedirectApiUrls